/* Experiencia ODARA — envío del registro.

   El formulario va en dos pasos a propósito: el flyer promete «en 2 minutos»,
   así que el primer paso guarda con lo mínimo y el segundo sólo enriquece. Si
   la persona abandona en el segundo, el registro ya está hecho. */
(function () {
  "use strict";

  var raiz = document.querySelector(".exp-odara");
  if (!raiz) return;

  var API = raiz.dataset.api;
  var form = raiz.querySelector("form");
  var listo = raiz.querySelector(".listo");
  var avisoError = raiz.querySelector(".aviso-error");
  var boton = raiz.querySelector(".enviar");
  var paso2 = raiz.querySelector('[data-paso="2"]');
  var paso1 = raiz.querySelector('[data-paso="1"]');
  var barra2 = raiz.querySelector('.paso-et i[data-b="2"]');
  var enPaso = 1;
  var guardado = null;
  /* Si ya era cliente sólo lo sabemos por la PRIMERA respuesta. En el paso 2 el
     endpoint siempre contesta que ya existía, porque lo acaba de crear el paso 1:
     usar ese dato saludaría con «qué gusto verte de nuevo» a alguien que se
     acaba de registrar. */
  var yaEraCliente = false;

  var $ = function (s) { return raiz.querySelector(s); };
  var val = function (n) { var e = form.elements[n]; return e ? String(e.value || "").trim() : ""; };
  var marcado = function (n) { var e = form.elements[n]; return e ? e.checked : false; };

  /* El origen y la campaña vienen en la URL: el mismo formulario sirve para el
     QR del pedido, para una lona en sucursal o para un anuncio, y cada uno
     queda contado por separado. Si no hay `?o=`, el servidor deduce el origen
     de la UTM (el QR trae utm_medium=qr-caja); antes se mandaba «qr» a todos y
     no había forma de separar el QR del resto. */
  function deLaUrl(clave, porOmision) {
    var v = new URLSearchParams(location.search).get(clave);
    return v ? v.slice(0, 40) : porOmision;
  }

  function mostrarError(campo, mensaje) {
    var e = form.elements[campo];
    var caja = e && e.closest(".campo");
    var et = caja && caja.querySelector(".yerro");
    if (e) e.setAttribute("aria-invalid", mensaje ? "true" : "false");
    if (et) { et.textContent = mensaje || ""; et.classList.toggle("va", Boolean(mensaje)); }
  }

  function validarPaso1() {
    var bien = true;
    mostrarError("nombre", ""); mostrarError("correo", ""); mostrarError("whatsapp", "");

    if (val("nombre").length < 2) { mostrarError("nombre", "Escribe tu nombre."); bien = false; }
    if (!/^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(val("correo"))) {
      mostrarError("correo", "Revisa tu correo, parece incompleto."); bien = false;
    }
    var tel = val("whatsapp").replace(/\D/g, "");
    if (tel && tel.length !== 10) {
      mostrarError("whatsapp", "Deben ser 10 dígitos, sin lada de país."); bien = false;
    }
    if (!marcado("aceptaPrivacidad")) {
      avisoError.textContent = "Para continuar necesitamos que aceptes el aviso de privacidad.";
      avisoError.classList.add("va");
      bien = false;
    } else { avisoError.classList.remove("va"); }
    return bien;
  }

  function reunir() {
    var mes = val("cumple_mes"), dia = val("cumple_dia");
    var intereses = [].slice.call(form.querySelectorAll('input[name="intereses"]:checked'))
                      .map(function (i) { return i.value; });
    return {
      nombre: val("nombre"),
      apellido: val("apellido"),
      correo: val("correo"),
      whatsapp: val("whatsapp"),
      cumpleanos: mes && dia ? mes + "-" + dia : "",
      esProfesional: val("esProfesional") === "si",
      oficio: val("oficio"),
      ciudad: val("ciudad"),
      intereses: intereses,
      aceptaCorreo: marcado("aceptaCorreo"),
      aceptaWhatsapp: marcado("aceptaWhatsapp"),
      aceptaPrivacidad: marcado("aceptaPrivacidad"),
      origen: deLaUrl("o", ""),
      campana: deLaUrl("c", ""),
      utm: {
        source: deLaUrl("utm_source", ""),
        medium: deLaUrl("utm_medium", ""),
        campaign: deLaUrl("utm_campaign", ""),
        content: deLaUrl("utm_content", ""),
      },
    };
  }

  function enviar(datos) {
    boton.disabled = true;
    var textoPrevio = boton.textContent;
    boton.textContent = "Guardando…";
    return fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datos),
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j.ok) {
          throw new Error((res.j.errores || ["No pudimos guardar tu registro."]).join(" "));
        }
        return res.j;
      })
      .finally(function () { boton.disabled = false; boton.textContent = textoPrevio; });
  }

  function terminar(respuesta) {
    form.style.display = "none";
    var cupon = respuesta && respuesta.cupon;
    var cajaCupon = $(".cupon");
    if (cupon && cajaCupon) {
      cajaCupon.querySelector(".cod").textContent = cupon;
      cajaCupon.style.display = "";
    } else if (cajaCupon) {
      cajaCupon.style.display = "none";
    }
    if (yaEraCliente) {
      var t = $(".listo h2");
      if (t) t.textContent = "¡Qué gusto verte de nuevo!";
      var p = $(".listo .sub");
      if (p) p.textContent = "Ya estabas con nosotros: actualizamos tus datos y tus preferencias.";
    }
    listo.classList.add("va");
    listo.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  /* ── Interacción ── */
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    if (enPaso === 1) {
      if (!validarPaso1()) return;
      enviar(reunir()).then(function (r) {
        guardado = r;
        yaEraCliente = Boolean(r.yaEstaba);
        enPaso = 2;
        paso1.style.display = "none";
        paso2.style.display = "";
        if (barra2) barra2.classList.add("va");
        boton.textContent = "Terminar";
        var saltar = $(".saltar");
        if (saltar) saltar.style.display = "";
        avisoError.classList.remove("va");
        paso2.scrollIntoView({ behavior: "smooth", block: "center" });
      }).catch(function (err) {
        avisoError.textContent = err.message;
        avisoError.classList.add("va");
      });
      return;
    }

    // Paso 2: vuelve a mandar todo, ahora con lo que enriqueció.
    enviar(reunir()).then(terminar).catch(function () {
      // Ya quedó registrado en el paso 1: no se le castiga con un error.
      terminar(guardado);
    });
  });

  var saltar = $(".saltar");
  if (saltar) saltar.addEventListener("click", function () { terminar(guardado); });

  // El oficio sólo tiene sentido si trabaja en belleza.
  form.addEventListener("change", function (e) {
    if (e.target.name !== "esProfesional") return;
    var caja = $(".campo-oficio");
    if (caja) caja.style.display = e.target.value === "si" ? "" : "none";
  });

  // Sólo dígitos en el teléfono, sin pelear con quien pega un número con espacios.
  var tel = form.elements.whatsapp;
  if (tel) tel.addEventListener("input", function () {
    this.value = this.value.replace(/[^\d\s()-]/g, "").slice(0, 16);
  });
})();
